import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import React from "react";

const StatusTimeline = ({ data }) => {
  const followUps = data?.insurance?.followUps || [];

  return (
    <>
      {/* Display data.rto.followUps array in the form of table with columms a Index No., Follow up data, Follow up stage , Follow up status */}

      {/* use tailwind and mui */}
      <Timeline position="right">
        {/* Display data as alternating timeline */}
        {followUps.map((followUp, index) => (
          <TimelineItem key={index}>
            <TimelineOppositeContent
              sx={{ m: "1rem 0 auto" }}
              align="right"
              variant="body2"
              color="text.secondary"
            >
              <Typography variant="body2" color="text.secondary">
                {
                  // convert the timestamp to a readable date
                  new Date(followUp.followUpDate).toLocaleDateString("en-IN", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                }
              </Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                //   make the dot color based on the next follow up date if date is in the past then make it red else make it green
                sx={{
                  backgroundColor: "#3671D5",
                }}
              >
                <Typography
                  variant="h6"
                  component="span"
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    lineHeight: "1.2rem",
                    textAlign: "center",
                    width: "1.2rem",
                    height: "1.2rem",
                  }}
                >
                  {index + 1}
                </Typography>
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent
              sx={{
                m: "0.4rem 0 auto",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="h6" component="span">
                  Status : {followUp?.followUpStatus}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  className="font-normal"
                >
                  Stage : {followUp?.followUpStage}
                </Typography>
                {followUp?.followUpRemarks && (
                    <Typography
                    variant="body2"
                    color="text.secondary"
                    className="font-normal"
                  >
                    Remarks : {followUp?.followUpRemarks}
                  </Typography>
                  )}
              </Box>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </>
  );
};

export default StatusTimeline;
